import { isFrequentRoute } from "@/lib/transitData";

export const wellingtonRouteDisplayOptions = Object.freeze({
  nightRouteColor: "#FFEE00",
});

export const getStopTypeDetails = (stopType) => {
  switch (stopType) {
    case "bus":
      return {
        name: "Bus Stop",
        servicesLabel: "Bus Services",
        color: "#F78824",
        darkColor: "#452F14",
        className: "text-orange-500",
      };
    case "train":
      return {
        name: "Train Station",
        servicesLabel: "Train Services",
        color: "#10B981",
        darkColor: "#193C32",
        className: "text-green-500",
      };
    case "cable_car":
    // TODO: Remove this camelCase fallback after deployed stop metadata has fully moved to cable_car.
    case "cableCar":
      return {
        name: "Cable Car Stop",
        servicesLabel: "Cable Car Services",
        color: "#DC2626",
        darkColor: "#3A1111",
        className: "text-red-500",
      };
    case "ferry":
      return {
        name: "Ferry Stop",
        servicesLabel: "Ferry Services",
        color: "#2563EB",
        darkColor: "#112057",
        className: "text-blue-500",
      };
    default:
      return {
        name: "Stop",
        servicesLabel: "Services",
        color: "#78716C",
        darkColor: "#4B5563",
        className: "text-zinc-500",
      };
  }
};

export const getRouteBadgeType = (routeType, routeLabel) => {
  switch (Number(routeType)) {
    case 5:
      return "cable_car";
    case 4:
      return "ferry";
    case 3:
      if (routeLabel?.startsWith("N")) {
        return "night";
      }

      return isFrequentRoute(routeLabel) ? "frequent" : "standard";
    case 2:
      return "train";
    case 712:
      return "school";
    default:
      return null;
  }
};

export const normalizeRouteBadgeColor = (routeColor) => {
  if (!routeColor) {
    return routeColor;
  }

  let normalizedRouteColor = routeColor;

  if (normalizedRouteColor === "#000000" || normalizedRouteColor === "000000") {
    normalizedRouteColor = "#222B2A";
  }

  if (!normalizedRouteColor.startsWith("#")) {
    normalizedRouteColor = `#${normalizedRouteColor}`;
  }

  return normalizedRouteColor;
};

export const normalizeRouteTextColor = (routeTextColor, fallback = "white") => {
  if (!routeTextColor) {
    return fallback;
  }

  let normalizedRouteTextColor = routeTextColor;

  if (!normalizedRouteTextColor.startsWith("#")) {
    normalizedRouteTextColor = `#${normalizedRouteTextColor}`;
  }

  return normalizedRouteTextColor;
};

export const getRouteBadgeSvgStyle = (type, routeColor) => {
  switch (type) {
    case "cable_car":
    // TODO: Remove this camelCase fallback after deployed route badges have fully moved to cable_car.
    case "cableCar":
      return {
        fillColor: "#CF112C",
        strokeColor: null,
        textColor: "#CEB590",
      };
    case "ferry":
    case "frequent":
      return {
        fillColor: routeColor,
        strokeColor: null,
        textColor: "white",
      };
    case "standard":
      return {
        fillColor: "white",
        strokeColor: routeColor,
        textColor: routeColor,
      };
    case "night":
      return {
        fillColor: "#FFF200",
        strokeColor: null,
        textColor: "#FFF200",
      };
    case "school":
      return {
        fillColor: "#FFF500",
        strokeColor: null,
        textColor: "rgba(0,0,0,.8)",
      };
    case "train":
      return {
        fillColor: routeColor,
        strokeColor: null,
        textColor: "rgba(0,0,0,.85)",
      };
    default:
      return {
        fillColor: "inherit",
        strokeColor: null,
        textColor: "black",
      };
  }
};

export const getRouteBadgeOgStyle = (type, routeColor) => {
  switch (type) {
    case "cable_car":
    // TODO: Remove this camelCase fallback after deployed route badges have fully moved to cable_car.
    case "cableCar":
      return {
        backgroundColor: "#CF112C",
        color: "#CEB590",
      };
    case "ferry":
    case "frequent":
      return {
        backgroundColor: routeColor,
        color: "white",
      };
    case "standard":
      return {
        backgroundColor: "white",
        color: routeColor,
        border: `4px solid ${routeColor}`,
      };
    case "night":
      return {
        background: "#101827",
        boxShadow: "inset -27px 0 0 0 #FFF200",
        color: "#FFF200",
        letterSpacing: "-5",
        paddingRight: 22,
      };
    case "school":
      return {
        backgroundColor: "#FFF500",
        color: "rgba(0,0,0,.8)",
      };
    case "train":
      return {
        backgroundColor: routeColor,
        color: "rgba(0,0,0,.85)",
      };
    default:
      return {
        backgroundColor: "#CCCCCC",
        color: "black",
        border: "4px solid #CCCCCC",
      };
  }
};
